import { render, staticRenderFns } from "./vehicleListTab.vue?vue&type=template&id=55ff455b"
import script from "./vehicleListTab.vue?vue&type=script&lang=js"
export * from "./vehicleListTab.vue?vue&type=script&lang=js"
import style0 from "./vehicleListTab.vue?vue&type=style&index=0&id=55ff455b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports